export default __webpack_public_path__ + "static/media/googlelogo_color_272x92dp.85707a33.png";